import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace PriceList {
    /**
    * 列表
    */
    export var GetPriceListList = (query: any): Promise<any> => {
        return Get(`/msls/PriceList/GetPriceListList?${qs.stringify(query)}`, {});
    };


    /**
  * 判断在一个时段是否有重复的运价信息
  */
    export var CheckPriceListInPeriod = (query: any): Promise<any> => {
        return Get(`/msls/PriceList/CheckPriceListInPeriod?${qs.stringify(query)}`, {});
    };


    /**
    * 详情
    */
    export var GetPriceListItem = (PriceListId: string): Promise<any> => {
        return Get(`/msls/PriceList/GetPriceListItem/${PriceListId}`, {});
    };
    /**
   * 详情
   */
    export var GetPriceListDetailList = (query: any): Promise<any> => {
        return Get(`/msls/PriceList/GetPriceListDetailList?${qs.stringify(query)}`, {});
    };
    /**
   * 获取基准价模板
   */
     export var GetJzjTemplate = (): Promise<any> => {
        return Download(`/msls/PriceList/GetBasePriceListExcelTemplate`, {});
    };
    /**
   * 获取发货方合同价模板
   */
     export var GetFhfhtTemplate = (): Promise<any> => {
        return Download(`/msls/PriceList/GetShipperPriceExcelTemplate`, {});
    };
     /**
   * 获取车队合同价模板
   */
      export var GetCdTemplate = (): Promise<any> => {
        return Download(`/msls/PriceList/GetCarrierPriceExcelTemplate`, {});
    };
    /**
  * 新增
  */
    export var AddPriceList = (body: any): Promise<any> => {
        return Post(`/msls/PriceList/AddPriceList`, body);
    };

    /**
   * 获取运价表模版
   */
    export var GetPriceListExcelTemplate = (id: string): Promise<any> => {
        return Download(`/msls/PriceList/GetPriceListExcelTemplate/${id}`, {});
    };
    /**
   * 导出
   */
    export var ExportPriceListExcel = (id: string): Promise<any> => {
        return Download(`/msls/PriceList/ExportPriceListExcel/${id}`, {});
    };
    /**
 * 导入
 */
    export var ImportPriceListDetail = (id: string, body: any): Promise<any> => {
        return Post(`/msls/PriceList/ImportPriceListDetail/${id}`, body);
    };
    /**
 * 基准价导入
 */
     export var ImportJzjListDetail = (id:any,body: any): Promise<any> => {
        if(id){
            return Post(`/msls/PriceList/ImportBasePriceList?id=${id}`, body);
        }else{
            return Post(`/msls/PriceList/ImportBasePriceList`, body);
        }
        
    };

    /**
 * 发货方or合同价导入
 */
     export var ImportSorcListDetail = (id:any,body: any): Promise<any> => {
        if(id){
            return Post(`/msls/PriceList/ImportPriceList?id=${id}`, body);
        }else{
            return Post(`/msls/PriceList/ImportPriceList`, body);
        }
        
    };

    /**
* 删除
*/
    export var DeletePriceList = (id: string): Promise<any> => {
        return Delete(`/msls/PriceList/DeletePriceList/${id}`, {});
    };
    /**
* 删除明细
*/
    export var DeletePriceListDetail = (id: string): Promise<any> => {
        return Delete(`/msls/PriceList/DeletePriceListDetail/${id}`, {});
    };
    /**
     * 修改
     */
    export var UpdatePriceList = (body: any): Promise<any> => {
        return Post(`/msls/PriceList/UpdatePriceList`, body);
    };

    /**
     * 立即生效
     */
    export var PriceListTakeEffect = (id: string): Promise<any> => {
        return Get(`/msls/PriceList/PriceListTakeEffect/${id}`, {});
    };

    /**
     * 立即失效
     */
    export var PriceListLoseEfficacy = (id: string): Promise<any> => {
        return Get(`/msls/PriceList/PriceListLoseEfficacy/${id}`, {});
    };

    

    /**
     * 新增基准价
     */
     export var addBaseList = (body: any): Promise<any> => {
        return Post(`/msls/PriceList/AddPriceList`, body);
    };

    /**
     * 新增发货方合同价
     */
     export var addFhfhtjList = (body: any): Promise<any> => {
        return Post(`/msls/PriceList/AddShipperPriceList`, body);
    };

    /**
     * 新增车队合同价
     */
     export var addCdhtList = (body: any): Promise<any> => {
        return Post(`/msls/PriceList/AddCarrierPriceList`, body);
    };
     /**
     * 发货方搜索
     */
      export var shipperList = (name: string): Promise<any> => {
        return Get(`/msls/Shipper/GetDropDownList?name=${name}`, {});
    };
    /**
     * 客户基地搜索
     */
     export var khjdList = (name: string): Promise<any> => {
        return Get(`/msls/CustomerBase/GetDropDownList?name=${name}`, {});
    };
    /**
     * 车队搜索
     */
     export var carrierList = (name: string): Promise<any> => {
        return Get(`/msls/Carrier/GetCarrierList?name=${name}`, {});
    };
    /**
     * 线路价格查询
     */
    export var GetCarrierPriceListDetailList = (query: any): Promise<any> => {
        return Get(`/msls/PriceList/GetCarrierPriceListDetailList?${qs.stringify(query)}`, {});
    };
}
